import votingDark from "@/assets/images/event-type-voting-dark.webp";
import concertDark from "@/assets/images/event-type-concert-dark.webp";
import karaokeDark from "@/assets/images/event-type-karaoke-dark.webp";

export const EVENT_TYPES = {
  PREVOTING: "prevoting",
  CONCERT: "concert",
  KARAOKE: "karaoke"
};

export const EVENT_TYPE_OPTIONS = [
  {
    value: EVENT_TYPES.PREVOTING,
    label: "Pre-voting",
    description: "Open voting ahead of the show to plan the first set or full playlist.",
    image: votingDark,
    selectable: true
  },
  {
    value: EVENT_TYPES.CONCERT,
    label: "Concert",
    description: "Full live concert control with voting, setlists, and performance tracking.",
    image: concertDark,
    selectable: true
  },
  {
    value: EVENT_TYPES.KARAOKE,
    label: "Karaoke",
    description: "Queue songs with performer names; staff controls start and end times.",
    image: karaokeDark,
    selectable: true
  }
];

export function getEventTypeLabel(eventType) {
  const normalized = normalizeEventType(eventType, null);
  if (!normalized) return "Concert";
  const option = EVENT_TYPE_OPTIONS.find((item) => item.value === normalized);
  return option?.label || "Concert";
}

export function resolveEventType(event) {
  if (!event) return EVENT_TYPES.CONCERT;
  if (event.eventType != null && String(event.eventType).trim() !== "") {
    return normalizeEventType(event.eventType);
  }
  return EVENT_TYPES.CONCERT;
}

export function getEventTypeLabelForEvent(event) {
  return getEventTypeLabel(resolveEventType(event));
}

export function getEventTypeShortCode(eventType) {
  switch (normalizeEventType(eventType, null)) {
    case EVENT_TYPES.PREVOTING:
      return "V";
    case EVENT_TYPES.KARAOKE:
      return "K";
    default:
      return "C";
  }
}

export function getEventTypeShortCodeForEvent(event) {
  return getEventTypeShortCode(resolveEventType(event));
}

export function getEventTypeImage(eventType) {
  const option = EVENT_TYPE_OPTIONS.find((item) => item.value === eventType);
  return option?.image || concertDark;
}

export function normalizeEventType(eventType, fallback = EVENT_TYPES.CONCERT) {
  if (!eventType) return fallback;
  const value = String(eventType).trim().toLowerCase();
  if (value === "prevoting" || value === "pre-voting" || value === "prevote") {
    return EVENT_TYPES.PREVOTING;
  }
  if (Object.values(EVENT_TYPES).includes(value)) {
    return value;
  }
  return fallback;
}

export function isPrevoting(eventType) {
  return normalizeEventType(eventType) === EVENT_TYPES.PREVOTING;
}

/**
 * Detect pre-voting events from persisted eventType.
 */
export function isPrevotingEvent(event) {
  return resolveEventType(event) === EVENT_TYPES.PREVOTING;
}

export function isKaraoke(eventType) {
  return normalizeEventType(eventType) === EVENT_TYPES.KARAOKE;
}

export function isKaraokeEvent(event) {
  return resolveEventType(event) === EVENT_TYPES.KARAOKE;
}

export function isSetlistAllowed(eventType) {
  return normalizeEventType(eventType) === EVENT_TYPES.CONCERT;
}

export function getEventTypeBadgeClass(eventType) {
  switch (eventType) {
    case EVENT_TYPES.PREVOTING:
      return "bg-amber-900/40 text-amber-200";
    case EVENT_TYPES.KARAOKE:
      return "bg-purple-900/40 text-purple-200";
    default:
      return "bg-teal-900/40 text-teal-200";
  }
}
